import { useState } from "react";
import { Linkedin, Twitter, Link2, Check } from "lucide-react";
import { toast } from "sonner";

export default function ShareBar({ title, idSuffix = "" }) {
  const [copied, setCopied] = useState(false);
  const url = window.location.href;
  const encodedUrl = encodeURIComponent(url);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy link");
    }
  };

  const btnClass =
    "inline-flex items-center gap-2 px-3.5 py-2 rounded-full border border-border font-manrope text-xs font-medium text-muted-foreground hover:text-foreground hover:border-brand-accent transition-colors duration-200";

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`share-bar${idSuffix}`}>
      <span className="overline mr-1">Share</span>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`share-linkedin-btn${idSuffix}`}
        className={btnClass}
      >
        <Linkedin size={14} className="text-brand-accent" />
        LinkedIn
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodeURIComponent(title || "")}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`share-twitter-btn${idSuffix}`}
        className={btnClass}
      >
        <Twitter size={14} className="text-brand-accent" />
        X
      </a>
      <button onClick={handleCopy} data-testid={`share-copy-btn${idSuffix}`} className={btnClass}>
        {copied ? <Check size={14} className="text-green-600" /> : <Link2 size={14} className="text-brand-accent" />}
        {copied ? "Copied" : "Copy link"}
      </button>
    </div>
  );
}
